import { json } from "react-router-dom";
import { FetchWithAuth } from "./utils/FetchWithAuth";

const apiUrl = process.env.REACT_APP_API_BASE+"/admin";

const buildRequestBody = (data) => {
  let hasFile = false;
  const formData = new FormData();

  // Check if any file exists
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value && value.rawFile instanceof File) {
      hasFile = true;
    }
  });

  // If has file → use FormData
  if (hasFile) {
    Object.keys(data).forEach((key) => {
      const value = data[key];

      if (value && value.rawFile instanceof File) {
        formData.append(key, value.rawFile);
        if (value.title) formData.append(`${key}_name`, value.title);
      } else {
        // FormData doesn’t support null → append empty string
        formData.append(key, value ?? "");
      }
    });

    return { body: formData, headers: {} };
  }

  // If no file → use JSON, keep nulls as null
  return {
    body: JSON.stringify(data),
    headers: { "Content-Type": "application/json" },
  };
};



const DataProvider = {
  getList: async (resource, params) => {
    const res = await FetchWithAuth(`${apiUrl}/${resource}.php`);
    const json_res = await res.json();
   
  return { data: json_res.data || [], total: json_res.total || 0 };
  },

  getOne: async (resource, params) => {
    const res = await FetchWithAuth(`${apiUrl}/${resource}.php?id=${params.id}`);
    const json_res = await res.json();
    return { data: json_res.data };
  },

  getMany: async (resource, params) => {
    // kirim ke PHP dengan ?ids=1,2,3
    const query = `ids=${params.ids.join(",")}`;
    const res = await FetchWithAuth(`${apiUrl}/${resource}.php?${query}`);

    const data = await res.json();

    return { data };
  },

  create: async (resource, params) => {
    // let body;
    // let headers = {};

    // if (params.data.image && params.data.image.rawFile instanceof File) {
    //   // === Kirim multipart/form-data ===
    //   body = new FormData();
    //   body.append("title", params.data.title);
    //   body.append("content", params.data.content);
    //   body.append("image", params.data.image.rawFile);
    // } else {
    //   // === Kirim JSON biasa ===
    //   body = JSON.stringify({
    //     title: params.data.title,
    //     content: params.data.content,
    //   });
    //   headers["Content-Type"] = "application/json";
    // }

    const { body, headers } = buildRequestBody(params.data);

    const res = await FetchWithAuth(`${apiUrl}/${resource}.php`, {
      method: "POST",
      body,
      headers,
    });

    const json = await res.json();
    //console.log(json);

    return { data: { ...params.data, id: json.id } };
  },

  update: async (resource, params) => {
    // let body;
    // let headers = {};
    
    // if (params.data.image && params.data.image.rawFile instanceof File) {
    //   // multipart/form-data jika ada file baru
    //   body = new FormData();
    //   body.append("title", params.data.title);
    //   body.append("content", params.data.content);
    //   body.append("image", params.data.image.rawFile);
    // } else {
    //   // JSON biasa kalau tidak ada file baru
    //   body = JSON.stringify({
    //     title: params.data.title,
    //     content: params.data.content,
    //     image: params.data.image || null, // tetap kirim image lama
    //   });
    //   headers["Content-Type"] = "application/json";
    // }

    const { body, headers } = buildRequestBody(params.data);

    
   
    const res = await FetchWithAuth(`${apiUrl}/${resource}.php?id=${params.id}&_method=PUT`, {
      method: "POST",
      body,
      headers,
    });

    const json = await res.json();
   
    

    return { data: { ...params.data, id: params.id } };
  },


  delete: async (resource, params) => {
   
    const res = await FetchWithAuth(`${apiUrl}/${resource}.php?id=${params.id}`, {
      method: "DELETE",
    });

    const json = await res.json();


    // react-admin expects at least { data: {id: ...} }
    return { data: { id: params.id } };
  },
  deleteMany: async (resource, params) => {
    const res = await FetchWithAuth(`${apiUrl}/${resource}.php`, {
      method: "DELETE",
      body: JSON.stringify({ ids: params.ids }), // kirim array id
      headers: {
        "Content-Type": "application/json",
      },
    });

    const json = await res.json();
    //console.log("DeleteMany Response:", json);

    return { data: params.ids }; // react-admin butuh array of ids
  },
};

export default DataProvider;
